module.exports = __webpack_public_path__ + "components/weather-icon/static/nightsnowshowers-834d72229e0ece67935bcbce6e374f9c.webp";